//引入、配置路由的相关信息
import Vue from 'vue';
import VueRouter from 'vue-router';
import MyLogin from '../views/MyLogin.vue';
import HomePage from '../views/HomePage.vue';
import CreateForm from '../views/CreateForm.vue'
import ManageForm from '../views/ManageForm.vue'

//1.Vue.use安装插件
Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        component: MyLogin
    },
    {
        path: '/HomePage',
        component: HomePage
    },
    {
        path: '/CreateForm',
        component: CreateForm
    },
    {
        path: '/ManageForm',
        component: ManageForm
    }

];

//2.创建路由对象
const router = new VueRouter({
    mode: 'hash',
    routes,

});

//3.将router对象导出
export default router;